// extracted by mini-css-extract-plugin
export default {"content":"yRwRy8scTqxoKOCzDJ_9","bannerContent":"M6evbCkIq50TKDzsiLum","placeHolderShimmer":"OzkZu7em8IJ7mArLjbpJ"};